<template>
    <div style="height:100%" >
        <nav class="navbar is-mobile is-fixed-top menuHP"  role="navigation" aria-label="main navigation" 
            style="height:100px">
         <div class="nabvar-brand" style="">
             <div class="logo"  >
                 <img src="@/assets/logo.png" class="logoImg"/>
             </div>
             <div :class="classBurger+active+' buttonBurger'"  style="float:right;vertical-align: top;" 
                 v-on:click="activeBurger">
             <a
                id="example-burger-progress"
                role="button"
                aria-label="menu"
                aria-expanded="false"
                data-target="main-menu-progress"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
             </div>
         </div>
            <div id="main-menu-progress" :class="classMenuBurger+active+' menuMobileBurger'"  >
            <div class="navbar-end" style="height:100px;" >
            
            <div class="navbar-item menuItem" >
                <s-button icon="basketball-ball" @onclick="openModalTest(1)" label="Tester" theme="is-small"/>
                
            </div>
            <div class="navbar-item menuItem" >
                 <s-button icon="chalkboard-teacher" @onclick="openModalTest(2)" theme="is-small" label="Tutoriel"/>
            </div>
             <div class="navbar-item menuItem" >
                <s-button icon="video" @onclick="openVideo()" theme="is-small" label="Découvrir"/>
            </div>
                <div class="navbar-item menuItem" >
                    <s-button icon="search" @onclick="visitClub(1)" theme="is-small" label="Rechercher un club"/>
                
            </div>
            <div class="navbar-item" style="color:white" v-show="$store.getters.getUser==null">
                <s-button theme="is-large is-info" @onclick="club" label="SE CONNECTER"/>
            </div>
            <div class="navbar-item" style="color:white" v-show="$store.getters.getUser!=null">
                <s-button theme="is-large is-success" @onclick="club" label="DEMARRER"/>
            </div>
            
            </div>
            </div>
        </nav>
        <div class="g_menuMobile" style="z-index:10">
            <table class="g_menuFooterMin">
                <tr>
                    <td class="g_headerFooter">
                    </td>
                </tr>
                <tr>
                    <td >
                        <s-button theme="is-primary " icon="basketball-ball" @onclick="openModalTest(1)" mode="V" label="Tester"/>
                        </td>
                    <td >
                         <s-button theme="is-warning" icon="chalkboard-teacher" mode="V" @onclick="openModalTest(2)" label="Tutoriel"/>
                    </td>
                    <td>
                         <s-button theme="is-danger" mode="V" icon="video" @onclick="openVideo()" label="Découvrir"/>
                    </td>
                    <td >
                          <s-button theme="is-info" mode="V" icon="search" @onclick="visitClub(1)" label="Rechercher mon club"/>
                    </td>
                    <td >
                         <s-button theme="is-success" mode="V" icon="play" @onclick="jumpLink('#login')" label="Se connecter"/>
                    </td>
                </tr>
            </table>
        </div>
      
        
        <div class="fondHP">
            <H1  class="titleHome"  >
                <s-l id="home_title">L'application dédiée aux concours de pétanque</s-l>
            </H1>
        </div>
        <div class="header2">
        <div class="subtitle" >
            <div class="ordinateur" >
                    &nbsp;
            </div>
        </div>
        <div class="explain">
            <s-l id="home_explain">Sur un ordinateur, sur une tablette et même sur votre portable, Il n'a jamais été aussi simple d'organiser des concours de pétanque ... <br/>Disponible sur le Web, vous pouvez également l'installer sur l'appareil de votre choix et l'utiliser comme une application classique           (<a v-on:click="explainModalInstall=true">en savoir plus</a>)</s-l>
            <s-modal 
                title="Installer votre application"
                :open="explainModalInstall"
                :close="true"
                @close="explainModalInstall=false">
                <s-l id="explain_install">Pour installer votre application, il faut cliquez sur ....</s-l>
            </s-modal>
            <div style="margin-top:10px">
                <s-you-tube id="video_home" theme="is-danger" label="Découvrez en vidéo" ref="DecouvrirVideo"/>
            </div>
        </div>
        </div>
        
        <atouts/>
        <ccm id="ccm" @event="openModalTest(1)"/>
        <jsj id="jsj"  @event="visitClub(1)"/>
        <jvo id="jvo" @event="openModalTest(2)" />
        <login id="login" @logout="logout" @club="club"/>
        <contact id="contact"/>
        
        <footer-home />
        <div class="blanck">
            &nbsp;
            </div>
        <tester v-show="mode==1" @compris="faireUnTest" :open="openTest" @close="openTest=false" title="Tester les concours">
            <div >
                <s-l id='modeEssaiHome'>Vous êtes sur le point de faire un concours en mode essai ! Vous allez pouvoir tester gratuitement tous les types de concours que propose l'application. Vous êtes cependant limité entre 32 et 35 joueurs et les joueurs sont inscrits par le système. Une fois vos tests terminés, nous vous invitons à créer un club et créer vos premiers concours !
                </s-l>
            </div>
        </tester>
        <tester v-show="mode==2" @compris="faireUnTuto" :open="openTuto" @close="openTuto=false" title="Suivre un tutoriel">
            <div >
                <s-l id='modeTutoHome'>Vous êtes sur le point de suivre un tutoriel ! Suivez bien les instructions...</s-l>
            </div>
        </tester>
        <waiting :open="modalStarting"/>
    </div>
</template>
<style scoped>

.buttonBurger{
    background-color: #FFD75C;
    color: #294294;
    border-radius: 20px;
    margin: 3px;
}
.menuHP {
    
    background: rgba(55, 88, 138, 0);
    height: 300px;
}



/*mobile*/
@media screen and (max-width: 1023px) {
     .blanck {
         height: 100px;
     }
     .menuAFooter {
         
        color:  var(--bluebg);
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
        padding-bottom: 20px;
    }
    .SButton {
        background-color: rgb(235, 234, 233);
        color:var(--bluebg);
        border-radius: 20px;
        border: none;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
        font-weight: bold;
        font-size: 20px;
    }
    .SButtonDemarrer {
        background-color: rgb(128, 216, 128);
        color:var(--bluebg);
        border-radius: 20px;
        border: none;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
        font-weight: bold;
        font-size: 20px;
    }
    .menuMobileBurger {
        background-color: #FFD75C;
        height: 700px;
        padding-top: 100px;
        text-align: center;
        color: var(--bluebg);
    }
    .menuMobileBurger div {
        padding-top: 25px;
    }
    a.menuA {
        color:  var(--bluebg);
        font-size: 20px;
        font-weight: bold;
        
    }
    
    .header2 {
       height: 530px;
       
    }
   .explain {
        float: left;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 14px;
        color: black;
        width: 100%;
        padding-top: 0px;
        padding-bottom: 20px;
        text-align: justify;
   } 
    .fondHP {
        background-image: url("../assets/header_HP.jpg");  
        background-repeat: no-repeat;
        height: 400px;
        width: 100%;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }
    .ordinateur {
        margin-top: -260px;
        background-image: url("../assets/ordinateur.png");
        background-repeat: no-repeat;
        width: 100%;
        background-position: center;
        background-size: 80%;
        height: 400px;
        margin-bottom: -120px;
       
    } 
    .subtitle {
        width: 100%;
        text-align: center;
    }
    .titleHome {
        width: 100%;
        padding-top:120px;
        padding-right: 40px;
        color: white;
        font-size: 25px;
        
        font-weight: bolder;
        padding-left: 20px;
    }
    .logo {
        float:left;
        vertical-align: top;
        background-color: white;
        border-radius: 0px 0px 15px 15px;
        padding-top: -10px;
        margin-left: 20px;
        width: 150px;
    }
    .logoImg {
        width:max-content;
    }
    
    /* **** COMMENT CA MARCHE ***/
    
}
/*desktop*/
@media screen and (min-width: 1023px) {
    .linkFooter {
        display: none;
        
    }
   
    .SButton {
        background-color: #FFD75C;
        border-radius: 20px;
        border: none;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
        color: var(--bluebg);
        font-weight: bold;
    }
    .SButtonDemarrer {
        background-color: rgb(91, 228, 79);
        border-radius: 20px;
        border: none;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
        color: var(--bluebg);
        font-weight: bold;
    }
     .menuMobileBurger {
        
    }
    a.menuA {
        color:  white;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
    }
    .header7 {
        margin-top: 0px;
        background-color: var(--bluebg);
        color: white;    
        height: 200px;
        padding: 10px;
    }
    .header2 {
        height: 260px;
    }
    .logo {
        float:left;
        vertical-align: top;
        background-color: white;
        border-radius: 0px 0px 15px 15px;
        padding-top: -10px;
        margin-left: 20px;
        width: 180px;
    }
    .logoImg {
        width:max-content;
    }
    .explain {
        float: left;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 18px;
        color: black;
        width: 50%;
        text-align: justify;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .fondHP {
        background-image: url("../assets/header_HP.jpg");
        background-repeat: no-repeat;
        height: 360px;
        width: 100%;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }
    .ordinateur {
        margin-top: -200px;
        background-image: url("../assets/ordinateur.png");
        background-repeat: no-repeat;
        width: 100%;
        background-position: right;
        background-size: contain;
        float: right;
        height: 400px;
        margin-bottom: -100px;
    } 
    .subtitle {
        width: 50%;
        min-width: 350px;
        float: right;
        text-align: right;
    } 
    .titleHome {
        width: 50%;
        padding-top:155px;
        padding-right: 40px;
        color: white;
        font-size: 45px;
        font-weight: bolder;
        padding-left: 20px;
        
    }
    
   iframe {
        width: 90%;
        max-width: 650px; /* Also helpful. Optional. */
   }
    
}

</style>
<script>
import navbar from "@/components/MyNavbar.vue"

import login from "@/views/auth/Login.vue"
import firebase from "firebase/app"
import atouts from "@/views/home/atouts.vue"
import ccm from "@/views/home/ccm.vue"
import jsj from "@/views/home/jsj.vue"
import jvo from "@/views/home/jvo.vue"
import contact from "@/views/home/contact.vue"
import footerHome from "@/views/home/footer.vue"
import tester from "@/views/auth/connectAnonyme.vue"

export default {
    components: {
        navbar,
        login,
        ccm,
        jsj,
        jvo,
        contact,
        footerHome,
        atouts,
        tester
    },
    data()  {
        return {
            email: "",
            confirmation: false,
            modalLogin: false,
            classBurger : "navbar-burger burger",
            classMenuBurger : "navbar-menu",
            active: "",
            info: "",
            explainModalInstall: false,
            modalVideo: false,
            playerVars: {
                autoplay: 0
            },
            openTest: false,
            openTuto: false,
            mode: 2,
            modalStarting: false
        }
    },
    computed: {
        user: {
            get() {
                return this.$store.getters.getUser;
            }
        }
        
    },
    beforeMount() {
        var test = this.$route.query.test;
      /*
        if (typeof(test)=="undefined")
            if (firebase_api.keys.config.projectId=="petanktest-966f4")
                window.location = "https://petanque-app.com"
        */
    },
    methods: {
        openVideo() {
            this.$refs["DecouvrirVideo"].openVideo();
        },
        faireUnTest() {
            this.modalStarting = true;
            this.$store.dispatch('init', ()=>{
                this.modalStarting = false;
                this.$router.push({name: 'concours', params: {id: "demo", test: true}})
            })
        },
        faireUnTuto() {
             this.modalStarting = true;
             this.$store.dispatch('init', ()=>{
                  this.modalStarting = false;
                this.$store.dispatch("setDemo", {demo: true});
             });
        },
        openModalTest(mode) {
            
            var reinitDemo = {
                active: false,
                admin: false,
                tuto: 0,
                badButton: false,
                idClub: null,
                idTournoi: null,
                idPartie: null,
                tutoriel: null,
                nbEquipes: 0,
                equipeCompleted: false
            }
            this.$store.dispatch("setUpdateDemo", reinitDemo);
            this.mode = mode;
            if (mode == 1)
                this.openTest = true;
            else
                this.openTuto = true;
        },
        visitClub() {
            this.$router.push({name: 'visit'}).catch(err=>{})
        },
        setInfo(info) {
            this.info = info;
        },
        activeBurger() {
            if (this.active == '') {
                this.active = 'is-active';         
                
            }
            else    
                this.active = '';
        },
        jumpLink(jump) {
            this.active = '';
            var block='';
            switch (jump) {
                case "#jsj":
                    block = "end";
                    break;
                case "#login":
                    block = "center";
                    break;
                case "#jvo":
                    block = "start";
                    break;
                default:
                    block = "start";
                    break;
               
            }
            
            const el = document.querySelector(jump);
             el && el.scrollIntoView( {
                 block: block,
                 behabior: 'smooth',
                 inline: 'nearest'
             });
        },
         club() {
             if (this.$store.getters.getUser==null) {
                 this.jumpLink("#login");
             } 
             else {
                this.$router.push({name: "club"}).catch(error=>{});
             }
        }, logout: function() {
            
            firebase
                .auth()
                .signOut()
                .then(() => {
                this.$store.dispatch('init',()=>{
                  
                    this.$router.push({name: "home"}).catch(error=>{});
                });
            });
            }
        ,
        video() {
            this.modalVideo = true;
         
        },
        closeVideo() {
            this.modalVideo = false;
            this.$refs.youtube.player.stopVideo();
        }
    }
   

}
</script>